export default {
  editDetailsTitle: 'Editar Detalles',
  cancel: 'Cancelar',
  save: 'Guardar',
  uploadingFile: 'Subiendo',
  loadingText: 'Cargando...',
  noDataText: 'No hay documentos disponibles para este modelo',
  uploadDocument: 'Subir documento',
  search: 'Buscar',
  headerName: 'Nombre',
  headerDetails: 'Detalles',
  headerSize: 'Tamaño',
  headerCreated: 'Creado',
  headerActions: 'Acciones',
  download: 'Descargar',
  editDetails: 'Editar Detalles',
  delete: 'Eliminar',
  warningTitle: 'Advertencia',
  deleting: 'Eliminando:',
  deleteConfirmation: 'Esta acción no se puede deshacer. ¿Estás seguro?',
  fileEdited: 'Archivo editado',
  deletingFile: 'Eliminando archivo',
  fileDeleted: 'Archivo eliminado',
  uploadError: 'Error al subir el archivo. Recuerda que los únicos tipos de archivo permitidos son XLSX, PDF y ZIP.'
}
